export default "__VITE_ASSET__CNwROUxV__"